import React, { useState, useEffect } from 'react';

import axios from "axios"
import Box from '@mui/material/Box';

import Container from '@mui/material/Container';

import HandAvator from './handAvatar.png';

import Typography from '@mui/material/Typography';

import AloeAvatar from "./AloeAvatar.png";

import { loadNFTInfo, approveArtGobbler, isNFTApproved, gobble, getTokenBalance } from '../../contract/contract'

import { useWeb3React } from "@web3-react/core"

import { Button } from '@mui/material';

import FileUpload from 'react-material-file-upload';

import Card from './CardComponent';

import Modal from '@mui/material/Modal';

import Grid from '@mui/material/Grid';

import Step1 from "./Step1.png";
import Step2 from "./Step2.png";
import Step3 from "./Step3.png";

import SwitchLine from "./SwitchLineCard"


import StepInfo from "./StepInfo";

import ReportCard from "./ReportCard"

function ImageUpload() {

  const [files, setFiles] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [info, setInfo] = useState({})

  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const [tokenBalance, setTokenBalance] = useState(0)

  const handleClose = () => {
    setOpen(false)
  }

  const handleFileChange = () => {
    if(files) {
      const file = files[0];
      setPreviewUrl(URL.createObjectURL(file));
      handleOpen()
    }
  };

  // useEffect( ()=> {
  //   if(files && files.length > 0) {
  //     handleFileChange()
  //   }
  // }, [files])

  const [score, setScore ] = useState(0)

  const [array, setArray] = useState([])

  const { active, account, library, connector, activate, deactivate, chainId } = useWeb3React()
  
  const showTokenBalance = async () => {
    if(account && active) {
      const balance = await getTokenBalance(library, account)
      setTokenBalance(balance)
      setScore(balance * 270)

      let score = balance * 270

      let array = [0, 1, 2 , 3]

      array[0] = {
        name: "matt.eth",
        score: score + 3229
      }
 
      array[1] = {
        name: "jeff.eth",
        score: score
      }

      array[2] = {
        name: "candice.eth",
        score: score - 1340
      }

      array[3] = {
        name: "zara.eth",
        score: score - 2582
      }

      setArray(array)
    
    }
  }
  
  useEffect(() => {
    showTokenBalance()
  }, [active])

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append('image', files[0]);
    try {
      const response = await axios.post('https://blooming-coast-82572.herokuapp.com/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      setInfo(response.data)
      
      // Handle successful response from the server
    } catch (error) {
      console.error(error);
      // Handle error from the server
    }
  };

  return <div style={{backgroundColor: "#131A22", color: "#DAD7CD", height: "130vh"}}>
        
    
           <Container maxWidth="xl">

           <StepInfo />
            
            <div style={{backgroundColor: "#FDFFFC", padding: "5%", marginTop: 20}}>
           <Grid container spacing={2} style={{color: "#344E41"}}>
                <Grid item xs={6}>
                    <Typography variant="h4" gutterBottom style={{marginBottom: 20, fontWeight: "bold"}}>
                        Sustainability Score
                    </Typography>
                    <SwitchLine 
                      img={AloeAvatar}
                      text1="Token Balance"
                      text2={tokenBalance}
                    />
                    <SwitchLine 
                      img={HandAvator}
                      text1="Sustainability Score"
                      text2={score}
                    />

                    <Typography variant="h4" gutterBottom style={{marginBottom: 20, color: "#344E41", fontWeight: "bold"}}>
                        Receipt Updates
                    </Typography>
                    <SwitchLine 
                      img={Step1}
                      text1="Company name"
                      text2="Macy"
                    />
                     <SwitchLine 
                      img={AloeAvatar}
                      text1="Token Earned"
                      text2={tokenBalance}
                    />
                    <SwitchLine 
                      img={HandAvator}
                      text1="Sustainability Score Earned"
                      text2={score}
                    />

                </Grid>
                <Grid item xs={6}>
                    
                    <Typography variant="h4" gutterBottom style={{marginBottom: 20, color: "#344E41", fontWeight: "bold"}}>
                        Leadership Board
                    </Typography>

                    <Box style={{background: "#FAF3DD", fontSize: 20, padding: 25, fontWeight: "bold", borderRadius: 10}}>
                        You are in the top 10% of Leadership Board. You have 200 more points than 3rd place.
                    </Box>

                    <Box style={{marginTop: 30}}>


                    </Box>
                     
                    {
                      array.map((item, index) => {
                        if(index == 1) {
                          return <ReportCard {...item} color="#FAF3DD"/>
                        } else {
                          return <ReportCard {...item} />
                        }
                      })
                    }

                </Grid>
            </Grid>
            </div>

           </Container>

         </div>

}

export default ImageUpload;